/**
 * How a message's attached file is named in the thread (assistant-ui attachments): `upload-<id>`, the upload it is.
 * Stored messages (`toThreadMessage`) and the optimistic bubble (`useConversationRuntime`) both use it, so the file's
 * own component can load it.
 */
const PREFIX = 'upload-';

export function messageAttachmentId(uploadId: number): string {
  return `${PREFIX}${uploadId}`;
}

export function uploadIdOfAttachment(attachmentId: string): number | null {
  if (!attachmentId.startsWith(PREFIX)) return null;
  const id = Number(attachmentId.slice(PREFIX.length));
  return Number.isSafeInteger(id) && id > 0 ? id : null;
}
